<template>
  <div class="parent-task">
    <span class="text" @click="openDialog">{{ parentTask.name }}</span>
    <detail-dialog
      :task-id="parentTask.id"
      :visible.sync="dialogVisible"
      @data-changed="dataChanged"
    ></detail-dialog>
  </div>
</template>

<script>
import Emitter from "@/mixins/emitter"

export default {
  name: "parent-task",
  props: {
    parentTask: Object
  },
  mixins: [Emitter],
  data() {
    return {
      dialogVisible: false
    }
  },
  beforeCreate() {
    this.$options.components.DetailDialog = require("@/components/Task/DetailDialog").default
  },
  methods: {
    openDialog() {
      if (!this.parentTask.id) return this.$message.error("父任务ID不存在，请刷新重试！")
      this.dialogVisible = true
    },
    dataChanged() {
      this.dispatch("detail-dialog", "init")
    }
  }
}
</script>

<style lang="scss" scoped>
.parent-task {
  .text {
    color: $color-main;
    cursor: pointer;
  }
}
</style>
